export const SUMMER = 'summer';
export const WINTER = 'winter';
